import type { CSSProperties } from 'react'
import { Icon } from '@iconify/react'

interface AppIconProps {
  icon: string
  size?: number
  className?: string
  style?: CSSProperties
}

export default function AppIcon({ icon, size = 20, className, style }: AppIconProps) {
  return <Icon icon={icon} width={size} height={size} className={className} style={style} />
}
